import styled from 'styled-components'

const Path = styled.path.attrs(({ isActive, opacity = 0.15 }) => {
  return { opacity: isActive ? 0.85 : opacity }
})`
  fill: currentColor;

  &:hover {
    opacity: 0.85;
  }
`

export default Path
